import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import type { RfidDocumentRow } from '@/services/rfid.service'
import { DocumentSummaryChip } from './DocumentSummaryChip'
import { RfidAppHeader } from './RfidAppHeader'
import { WizardSteps } from './WizardSteps'
import { cn } from '@/utils/cn'

export type DocumentWizardShellProps = {
  step: number
  title: string
  subtitle?: string
  onBack: () => void
  onHome?: () => void
  document?: RfidDocumentRow | null
  customerNumber?: string
  hideDocumentSummary?: boolean
  headerContent?: ReactNode
  footer?: ReactNode
  children: ReactNode
  className?: string
  /** Extra class on the scrollable body (e.g. for scan layout). */
  bodyClassName?: string
}

export function DocumentWizardShell({
  step,
  title,
  subtitle,
  onBack,
  onHome,
  document,
  customerNumber,
  hideDocumentSummary,
  headerContent,
  footer,
  children,
  className,
  bodyClassName,
}: DocumentWizardShellProps) {
  const navigate = useNavigate()
  const handleHome = onHome ?? (() => navigate('/'))

  return (
    <div className={cn('rfid-web-frame', className)}>
      <RfidAppHeader
        title={title}
        subtitle={subtitle}
        onBack={onBack}
        onHome={handleHome}
      />
      <WizardSteps current={step} />

      <div className={cn('rfid-wizard-body', bodyClassName)}>
        {document && !hideDocumentSummary ? (
          <DocumentSummaryChip document={document} customerNumber={customerNumber} />
        ) : null}
        {headerContent}
        {children}
      </div>

      {footer ? <div className="rfid-footer-dock shrink-0">{footer}</div> : null}
    </div>
  )
}
